import React from "react";
import SalesforceActions from "./Actions/SalesforceActions";
import ScheduleFollowUp from "./Actions/ScheduleFollowUp";
import Tasks from "./Actions/Tasks";
import "./Actions.css";

const Actions = ({ onNavigateToTab, sfContext, sfAuthError, emailInfo, sfSession, refreshSfToken }) => {
    console.log("Rendering Actions with context:", sfContext, "and auth error:", sfAuthError);
    return (
        <div className="actions-tab-container">
            
            <SalesforceActions onNavigateToTab={onNavigateToTab} sfContext={sfContext} sfAuthError={sfAuthError} emailInfo={emailInfo} sfSession={sfSession} refreshSfToken={refreshSfToken} />
            <ScheduleFollowUp sfContext={sfContext} sfAuthError={sfAuthError} sfSession={sfSession} refreshSfToken={refreshSfToken} />
            <Tasks sfContext={sfContext} sfAuthError={sfAuthError} sfSession={sfSession} refreshSfToken={refreshSfToken} />
        </div>
    );
};

export default Actions;
